import install from '~/javascripts/helper/sentry'

export default () => {
  install()
}
